import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import CreativeSingle from '../../components/molecules/CreativeSingle';
import { modalHide, modalShow } from '../../store/modal/actions';
import { emptyEditRecord, setEditRecord } from '../../store/updateCreative/actions';

const CreativeSingleContainer = props => <CreativeSingle {...props} />;

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({
  showCreativeModal: creative => {
    if (get(creative, 'creative_service_id')) {
      dispatch(setEditRecord(creative));
    }

    dispatch(modalShow('create-creative'));
  },
  onCancel: () => {
    dispatch(modalHide('create-creative'));

    // Timeout because hiding is a slow fade.
    // We don't want to flash the form resetting
    setTimeout(() => dispatch(emptyEditRecord()), 100);
  },
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CreativeSingleContainer);
